import Graph from './container';

export default Graph;
